import styled from 'styled-components'

export const Info = styled.div`
  display: grid;
  grid-template-columns: 64.6rem 46.6rem;
  align-items: center;
  gap: 4.8rem;
  margin-top: -3.5rem;
  margin-bottom: 8.5rem;

  @media (max-width: 1279px) {
    margin-top: 0;
    margin-bottom: 8rem;
    grid-template-columns: 47.7rem 36.3rem;
    gap: 8rem;
  }

  @media (max-width: 999px) {
    width: 59rem;
    display: flex;
    flex-direction: column;
    gap: 4rem;
  }

  @media (max-width: 767px) {
    width: 100%;
    gap: 3rem;
    margin-bottom: 7rem;
  }
`

export const Text = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 400;
  font-family: Navigo, Arial, Helvetica, sans-serif;
  color: #292e3d;
`
export const Example = styled.div`
  background-color: #f9fafb;
  border-radius: 1rem;
  padding: 3rem 8rem 3rem 3rem;

  p {
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    color: #525c7a;
    margin: 0;
  }

  h5 {
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 400;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    color: #525c7a;
    margin: 0;
  }

  @media (max-width: 1279px) {
    padding: 0.5rem 2.5rem 3rem 3rem;
  }

  @media (max-width: 999px) {
    padding: 3.5rem 9rem 3rem 3rem;
  }

  @media (max-width: 767px) {
    padding: 3.5rem 2rem 2rem 2rem;
  }
`

export const TitleWrapper = styled.div`
  margin-bottom: 1.3rem;
  background-color: #fff;
  display: inline-flex;
  border-radius: 3rem;
  padding: 4px 1.5rem;

  @media (max-width: 999px) {
    padding: 0 1.5rem;
    margin-bottom: 1.7rem;
  }
`
